module.exports = __webpack_public_path__ + "img/cibeles.155ea5c2.png";